import { Box, ButtonProps, Stack, styled } from '@mui/material';
import { Body1 } from '@/components/@IntranetLibrary/Typography';
import Button from '@mui/material/Button';
import React from 'react';
import SortIcon from '@/public/icons/sort.svg';

export const FileWrapperClassName = 'attachment-file-wrapper';

export const Wrapper = styled(Stack)`
  &.mobile-style {
    gap: 24px;

    .${FileWrapperClassName} {
      grid-template-columns: 1fr;
    }

    .BoardDetailComment-header {
      padding: 0;
    }
  }

  &.top-style {
    #board-detail-comment-input-wrapper {
      margin-top: 24px;
    }

    .BoardDetailComment-header {
      padding: 12px 0;
    }
  }

  &.fixed-style {
    .comment-wrapper {
      margin-bottom: ${168 + 16}px;
    }

    .BoardDetailComment-header {
      padding: 12px 0;
    }

    #board-detail-comment-input-layout {
      position: fixed;
      z-index: 1;
      left: 0;
      right: 0;
      bottom: 0;
      margin: 0 auto;
      max-width: var(--page-max-width) !important;
      user-select: none;
    }

    #board-detail-comment-input-wrapper {
      width: calc(var(--detail-comment-width) + 1px);
      margin: 0 0 0 auto;
      padding: 20px 16px 32px;
      box-sizing: border-box;
      background: var(--dk-bg, #fff);
      border-top: 1px solid var(--dk-line, #e7e9ec);
      border-left: 1px solid var(--dk-line, #e7e9ec);

      @media screen and (max-width: 1939px) {
        margin: 0 20px 0 auto;
        padding: 20px 20px 32px;
      }
    }

    .${FileWrapperClassName} {
      grid-template-columns: 1fr;
    }
  }

  &.fixed-not-focus {
    .BoardDetailComment-header {
      padding: 12px 0;
    }
  }

  &.sheet-style {
    gap: 0;

    .BoardDetailComment-header {
      padding: 0;
      margin-top: 24px;
      /* Gray baseline across full width */
      border-bottom: 1px solid var(--dk-line, #e7e9ec);
    }

    #board-detail-comment-input-wrapper {
      margin-top: 16px;
    }
  }
`;

export const CommentListWrapper = styled(Stack)``;

export const HeaderTitle = styled(Body1)`
  font-weight: 700;
  text-decoration: underline;
  text-underline-offset: 5px;
  text-decoration-thickness: 1px;

  /* Sheet mode: tab-bar style with black underline overlapping gray baseline */
  .sheet-style & {
    position: relative;
    text-decoration: none;
    padding-bottom: 12px;

    /* Black underline positioned at same y as parent's border-bottom */
    &::after {
      content: '';
      position: absolute;
      left: 0;
      right: 0;
      bottom: -1px; /* Align with parent's 1px border-bottom */
      height: 2px;
      background-color: #000;
    }
  }
`;

export const SortWrapper = styled(Stack)`
  margin-left: auto;
  flex-direction: row;
  justify-content: end;
  align-items: center;
`;

export const SortButton = styled(({ children, ...props }: ButtonProps) => (
  <Button id={'comment-sort-menu-button'} aria-haspopup={'true'} {...props}>
    <Box width={'24px'} height={'24px'} marginRight={'4px'}>
      <SortIcon />
    </Box>
    {children}
  </Button>
))(() => ({
  padding: 0,
  paddingRight: '4px',
  fontSize: '14px',
  color: 'var(--dk-text, black)',
}));
